export const getFolders = (state) => state.folders
